var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lab"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1462 11.9998C11.5102 7.91421 9.60061 6.8374 9.60061 4.7998V2.3998H10.0006C10.1067 2.3998 10.2084 2.35766 10.2835 2.28265C10.3585 2.20763 10.4006 2.10589 10.4006 1.9998V1.1998C10.4006 1.09372 10.3585 0.991977 10.2835 0.916962C10.2084 0.841947 10.1067 0.799805 10.0006 0.799805H6.00061C5.89452 0.799805 5.79278 0.841947 5.71777 0.916962C5.64275 0.991977 5.60061 1.09372 5.60061 1.1998V1.9998C5.60061 2.10589 5.64275 2.20763 5.71777 2.28265C5.79278 2.35766 5.89452 2.3998 6.00061 2.3998H6.40061V4.7998C6.40061 6.8374 4.49101 7.91421 2.85501 11.9998C2.33421 13.2998 0.996611 15.1998 8.00061 15.1998C15.0046 15.1998 13.667 13.2998 13.1462 11.9998ZM11.8526 13.4006C11.291 13.5686 10.1734 13.7598 8.00061 13.7598C5.82781 13.7598 4.71021 13.5686 4.14861 13.4006C3.94941 13.3414 3.87181 13.1102 3.94221 12.8982C4.11821 12.3622 4.45021 11.4358 5.07101 10.4014C6.58781 7.8742 8.16141 10.799 9.47101 10.799C10.7806 10.799 10.4214 9.5502 10.9302 10.4014C11.3984 11.189 11.777 12.0264 12.059 12.8982C12.1294 13.1102 12.0518 13.3406 11.8526 13.4006Z",
    fill: "#42389D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/Lab.3ced910818acf932745abd1169388a9a.svg";
export { ForwardRef as ReactComponent };